import { useEffect, useState, useMemo } from "react";
import { useAuth } from "@/lib/auth-context";
import * as api from "@/lib/api";
import { UserManagementPanel } from "@/components/user-management-panel";

const allSponsorRoles = [
  { value: "sponsor_admin", label: "Sponsor Admin", scopeType: "sponsor" },
  { value: "sponsor_user", label: "Sponsor User", scopeType: "sponsor" },
];

export default function SponsorUsersPage() {
  const { user: authUser } = useAuth();
  const [sponsorName, setSponsorName] = useState("");

  const sponsorId = authUser?.roles.find(
    (r) => r.role_type === "sponsor_admin" && r.scope_type === "sponsor",
  )?.scope_id;

  // sponsor_admin can only assign sponsor_user; org_admin/super_admin can assign both
  const assignableRoles = useMemo(() => {
    const isSponsorAdminOnly =
      !authUser?.roles.some((r) => r.role_type === "super_admin" && r.scope_type === "platform") &&
      !authUser?.roles.some((r) => r.role_type === "org_admin" && r.scope_type === "organization");
    if (isSponsorAdminOnly) return allSponsorRoles.filter((r) => r.value === "sponsor_user");
    return allSponsorRoles;
  }, [authUser?.roles]);

  useEffect(() => {
    if (sponsorId) {
      api.getSponsor(sponsorId).then((r) => setSponsorName(r.sponsor.name)).catch(() => {});
    }
  }, [sponsorId]);

  if (!sponsorId) {
    return <p className="text-muted-foreground">No sponsor access</p>;
  }

  return (
    <div data-page="sponsor-users">
    <UserManagementPanel
      title="Manage Users"
      subtitle={sponsorName}
      scopeType="sponsor"
      scopeId={sponsorId}
      fetchUsers={() => api.getUsers()}
      assignableRoles={assignableRoles}
      canManage={true}
      showDetailLink
    />
    </div>
  );
}
